import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import "../style/MobileMenu.css";
export class MobileMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileMenuOpen: false
    };
    this.toggleOpen = this.toggleOpen.bind(this);
    this.renderThumbButtonArrow = this.renderThumbButtonArrow.bind(this);
  }
  toggleOpen() {
    this.setState(prevState => {
      return {
        mobileMenuOpen: !prevState.mobileMenuOpen
      };
    });
  }
  renderMobileNavItems(navItems) {
    return navItems.map(item => {
      return (
        <NavLink
          onClick={() => this.setState({ mobileMenuOpen: false })}
          to={item.url}
          key={item.url}
          className="mobile-nav-item"
        >
          <div>{item.title}</div>
        </NavLink>
      );
    });
  }
  renderThumbButtonArrow() {
    if (this.state.mobileMenuOpen) {
      return (
        <svg width="40" height="40" xmlns="http://www.w3.org/2000/svg">
          <g transform="rotate(180 20 20)" stroke="null" id="svg_6">
            <g transform="translate(-4.094 -4.16) scale(.37287)" id="svg_4">
              <path
                id="svg_5"
                d="m52.417117,90.043819c0.2,0.2 0.4,0.3 0.7,0.3c0.3,0 0.5,-0.1 0.7,-0.3l23,-24.5c0.4,-0.4 0.4,-1 0,-1.4l-23,-24.5c-0.4,-0.4 -1,-0.4 -1.4,0c-0.4,0.4 -0.4,1 0,1.4l22.3,23.8l-22.3,23.8c-0.4,0.4 -0.4,1.1 0,1.4z"
              />
            </g>
          </g>
        </svg>
      );
    } else {
      return (
        <svg width="40" height="40" xmlns="http://www.w3.org/2000/svg">
          <g stroke="null" id="svg_6">
            <g transform="translate(-4.094 -4.16) scale(.37287)" id="svg_4">
              <path
                id="svg_5"
                d="m52.417117,90.043819c0.2,0.2 0.4,0.3 0.7,0.3c0.3,0 0.5,-0.1 0.7,-0.3l23,-24.5c0.4,-0.4 0.4,-1 0,-1.4l-23,-24.5c-0.4,-0.4 -1,-0.4 -1.4,0c-0.4,0.4 -0.4,1 0,1.4l22.3,23.8l-22.3,23.8c-0.4,0.4 -0.4,1.1 0,1.4z"
              />
            </g>
          </g>
        </svg>
      );
    }
  }
  render() {
    const { navItems } = this.props;
    return (
      <div
        className={
          this.state.mobileMenuOpen ? `mobile-menu-open` : `mobile-menu`
        }
      >
        <div className="thumb-button" onClick={this.toggleOpen}>
          <div className="thumb-icon">{this.renderThumbButtonArrow()}</div>
        </div>
        <div className="mobile-nav-list">
          {this.renderMobileNavItems(navItems)}
        </div>
      </div>
    );
  }
}

export default MobileMenu;



// WEBPACK FOOTER //
// ./src/components/MobileMenu.js